import React from 'react'
import PropTypes from 'prop-types'
import { localized } from 'decorators'
import { isNotNull } from 'utils/isNotNull'
import { EnumSelect } from './enumSelect'
import { LookupSelect } from './lookupSelect'
import { SimpleSelect } from './_simpleSelect'

const Select = (props) => {

  if (isNotNull(props.enum)) { return <EnumSelect {...props} /> }
  if (isNotNull(props.dataSource)) { return <LookupSelect {...props} /> }

  return <SimpleSelect {...props} />
}

Select.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string, PropTypes.array]),
  onChange: PropTypes.func,
  valueField: PropTypes.string,
  textField: PropTypes.string,
  nullable: PropTypes.bool
}
Select.defaultProps = {
  valueField: 'id',
  textField: 'name',
  nullable: false
}

export default localized(Select)
